// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { Volume } from './Volume';
import { PrismRange } from './PrismRange';
import { Polygon2D } from './Polygon2D';
import { Coordinate } from './Coordinate';
import { Airspace } from './Airspace';

export class VolumePrism implements IVolumePrism {
    range!: PrismRange;
    polygon!: Polygon2D;

    constructor(data?: IVolumePrism) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.range = _data["range"] ? PrismRange.fromJS(_data["range"]) : <any>undefined;
            this.polygon = _data["polygon"] ? Polygon2D.fromJS(_data["polygon"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VolumePrism {
        data = typeof data === 'object' ? data : {};
        let result = new VolumePrism();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["range"] = this.range ? this.range.toJSON() : <any>undefined;
        data["polygon"] = this.polygon ? this.polygon.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVolumePrism {
    range: PrismRange;
    polygon: Polygon2D;
}